import { makeStyles, shorthands } from '@fluentui/react-components';

const getHomePageGenerateWithAIComponentStyle = makeStyles({
  footerContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'left',
    width: '100%',
  },
  subHeading: {
    display: 'flex',
    flexDirection: 'column',
    fontWeight: 600,
    lineHeight: '26px',
    fontFamily: 'Segoe UI',
    fontSize: '20px',
    textAlign: 'left',
    marginBottom: '8px',
  },
  paragraph: {
    display: 'flex',
    flexDirection: 'column',
    fontFamily: 'Segoe UI',
    fontSize: '14px',
    fontWeight: 200,
    lineHeight: '20px',
    textAlign: 'left',
    marginBottom: '20px',
  },
  searchBoxWrapper: {
    position: 'relative',
    width: '345px',
  },
  searchBox: {
    width: '100%',
    paddingRight: '30px',
  },
  sendIcon: {
    position: 'absolute',
    bottom: '6px',
    right: '6px',
    cursor: 'pointer',
  },
  imageRowContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    ...shorthands.gap('16px'),
    marginTop: '16px',
    flexWrap: 'nowrap',
  },
  imageWrapper: {
    flexShrink: 0,
    position: 'relative',
    width: '246px',
    height: '200px',
    ...shorthands.borderRadius('8px'),
    '&:hover .overlay, &:focus-within .overlay': {
      opacity: 1,
      transform: 'translateY(0)',
    },
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    ...shorthands.borderRadius('8px'),
  },
  overlay: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    paddingLeft: '16px',
    color: '#fff',
    opacity: 0,
    transitionProperty: 'opacity',
    transitionDuration: '0.3s',
    transitionTimingFunction: 'ease',
    pointerEvents: 'none',
  },
  overlayText: {
    color: '#FFF',
    fontFamily: 'Segoe UI',
    fontSize: '14px',
    fontStyle: 'normal',
    lineHeight: 'normal',
    marginBottom: '8px',
    fontWeight: 400,
    textAlign: 'left',
    marginLeft: '12px',
    marginRight: '12px',
  },
  overlayButton: {
    backgroundColor: 'transparent',
    color: '#fff',
    ...shorthands.borderRadius('4px'),
    cursor: 'pointer',
    textAlign: 'left',
    marginLeft: '12px',
    pointerEvents: 'all',
    '&:hover': {
      backgroundColor: 'transparent',
      color: '#fff',
    },
    '&:focus': {
      outlineColor: '#fff',
    },
  },
});

export default getHomePageGenerateWithAIComponentStyle;
